/**
 * These are the default options used by any transformation operation.
 */
export var defaultOptions = {
    enableCircularCheck: false,
    enableImplicitConversion: false,
    excludeExtraneousValues: false,
    excludePrefixes: undefined,
    exposeDefaultValues: false,
    exposeUnsetFields: true,
    groups: undefined,
    ignoreDecorators: false,
    strategy: undefined,
    targetMaps: undefined,
    version: undefined,
};
//# sourceMappingURL=default-options.constant.js.map


//////////////////
// WEBPACK FOOTER
// ./~/class-transformer/esm5/constants/default-options.constant.js
// module id = 778
// module chunks = 3